import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PriceBlock from '@hpstellar/core/PriceBlock';

import { Helpers } from '../../../core/src/helpers';
import { withProductPrice } from './with-product-price';
import { withError } from '../../../shared/components/error-boundary';

import './product-price-v2.less';

/**
 * Product price component displays price and promotions for the given product
 */
class ProductPriceV2 extends React.Component {
    static propTypes = {
        /**The product object { sku, itemId, prodId, prdClass }] */
        product: PropTypes.object.isRequired,
        /**Price and inventory information*/
        price: PropTypes.object,
        /**Callback function for fetching price info if price object is missing*/
        fetchPrices: PropTypes.func,
        /** Override price with a total price object */
        totalPrice: PropTypes.object,
        /** Price object added to price */
        addOnPrice: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.getMinimumVariantPrice = this.getMinimumVariantPrice.bind(this);
        const { product } = props || {};
        //flag product price for prefetch on
        if(typeof window === 'undefined' && product && product.itemId){
            const isParentPrd = product.prdClass === 'PRT' && product.sku === product.itemId;
            this.props.viewPrice(isParentPrd ? product.prodId : product.itemId);
        }
    }

    componentDidMount() {
        this.fetchProductPrice();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.product.itemId !== this.props.product.itemId) {
            this.fetchProductPrice();
        }
    }

    fetchProductPrice = () => {
        const { price, product } = this.props;
        const isParentPrd = product.prdClass === 'PRT' && product.sku === product.itemId;
        if (price.regularPrice === '' && product.itemId && product.prdClass !== 'EXT') {
            //TODO: Figure out a better way to get parent product pricing
            this.props.fetchPrices(
                isParentPrd ? [product.prodId] : [product.itemId]
            );
        }
    };

    getMinimumVariantPrice(items) {
        return Object.keys(items).reduce((minPrice, key) => {
            let item = items[key];
            let price = item.salePrice || item.regularPrice;
            if (price < minPrice) {
                return price;
            } else {
                return minPrice;
            }
        }, Number.MAX_SAFE_INTEGER);
    }

    render() {
        let {
            product,
            price,
            user,
            deal,
            variantId,
            pricePrefixText = '',
            className,
            totalPrice = null,
            addOnPrice = null,
            ...otherProps
        } = this.props;
        const hasVariantPricing =
            Helpers.isGiftCard(product) &&
            price.items &&
            Object.keys(price.items).length;
        let salePrice =
            (deal && deal.dealPrice * 1) || price.salePrice || price.regularPrice;
        let defaultPrefixText =
            product.prdClass === 'CTO' || (hasVariantPricing && !variantId)
                ? 'Starting at '
                : null;
        pricePrefixText = pricePrefixText || defaultPrefixText;

        if (hasVariantPricing) {
            const itemPrice = price.items[variantId];
            salePrice = itemPrice
                ? itemPrice.salePrice || itemPrice.regularPrice
                : this.getMinimumVariantPrice(price.items);
        }

        //don't show price for 'supplies' type products
        if (price.productType === 'supplies') {
            return <div className="prd-price"></div>;
        }
        

        price = Object.assign({}, price, { salePrice });

        //total price should override all mainly because of bundling
        if (totalPrice) {
            price = Object.assign({}, price, totalPrice);
        }else if(addOnPrice){
             addOnPrice.regularPrice && (price.regularPrice += addOnPrice.regularPrice);
             addOnPrice.salePrice && (price.salePrice += addOnPrice.salePrice);
        }
		
		const regularPriceLabel = Helpers.formatCurrency(price.regularPrice,undefined,true);
		const salePriceLabel = Helpers.formatCurrency(price.salePrice,undefined,true);
		const priceAriaLabel = `Sale price starting at ${salePriceLabel}.` + (price.regularPrice > price.salePrice ? ` Regular price starting at ${regularPriceLabel}` : "");
        const tierMsg = user && user.TierPriceMsg && price.tierPrice
        ? user.TierPriceMsg
        : null;
        return (<>
                <PriceBlock 
                    hasActiveDeal={deal} 
                    regularPrice={price.regularPrice} 
                    salePrice={price.salePrice}
                    disclaimer={price.inCartPrice && 'See price in cart'}
                    tierMsg={tierMsg}
                    aria-label={priceAriaLabel}
                    className={className}
                    productType={product.prdClass}
                    {...otherProps}
                />
                <div className={'prd-price-v2'}>
                {
                    price.isccf ? (
                        <div className='ccf-price'>
                            <div className="call-center">
                                <div className="gm-points">
                                    GM: {Helpers.formatCurrency(price.gmPoints)}
                                </div>
                                <div className="inv-count">Stock: {price.stock}</div>
                            </div>
                        </div>
                    ) : null
                }
                </div>
            </>);
    }
}

const mapStateToProps = (state, ownProps) => (
    {
        price: ownProps.price,
        user: state.userData.profileData.personData
    }
)

export default withProductPrice(connect(mapStateToProps, null)( withError(ProductPriceV2, <div className={"prd-price"} />)));